var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"header-class":"header-left-align bg-dark","nav-alignment":"left","show-top-header":false,"header-type":2,"footer-style":4}},[_c('div',{staticClass:"main-content"},[_c('iframe',{attrs:{"src":"/otdr"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }